import React, {useEffect, useState} from 'react';
import NavBar from "./components/NavBar";
import {BrowserRouter as Router, Route, Routes, useLocation} from 'react-router-dom'; // Import React Router
import Claims from "./pages/Claims";
import Caso from "./components/Caso"
import Powerbi from "./components/Powerbi";
import PowerbiMobile from "./components/PowerbiMobile";
import PowerbiOperaciones from "./components/PowerbiOperaciones";
import PowerbiOperacionesMobile from "./components/PowerbiOperacionesMobile";
import ReporteCliente from "./components/ReporteCliente";
import NotFound from "./components/NotFound";
import {AuthProvider} from "./components/auth/AuthProvider";
import Login from "./components/Login";
import {ProtectedRoute} from "./components/auth/ProtectedRoute";
import { HeroUIProvider } from "@heroui/react";
import ClaimDetailPublic from "./pages/ClaimDetailPublic";
import Maestra from "./pages/Maestra";
import LegacyPublic from "./pages/LegacyPublic";
import Carrier from "./pages/Carrier";
import Exporter from "./pages/Exporter";
import ExporterActivateAccount from "./pages/Exporter/ExporterActivateAccount";
import { Toaster } from "sonner";

const routeNames = {
    '': 'Claims',  // Para la ruta raíz
    'case': 'Caso',
    'maestra': 'Maestra',
    'powerbi': 'PowerBI',
    'powerbi-mobile': 'PowerBI Mobile'
};

// Componente separado para manejar la lógica de ubicación
function LocationHandler({ setSelectedMenu, setShowNavBar }) {
    const location = useLocation();

    useEffect(() => {
        const currentPath = location.pathname.slice(1);
        // Usa el mapeo si existe, de lo contrario usa el nombre de la ruta
        setSelectedMenu(routeNames[currentPath] || currentPath || 'Claims');

        // Actualiza si el NavBar debe mostrarse o no
        const hideNavBarRoutes = [
            'powerbi-mobile',
            'powerbi',
            'powerbi-operaciones',
            'powerbi-operaciones-mobile',
            'reporte',
            'claimdetail',
            '404',
            'login',
            'legacy',
            'carrier',
            'exporter',
            'exporteractivate'
        ];
        setShowNavBar(!hideNavBarRoutes.includes(currentPath));
    },[location, setSelectedMenu, setShowNavBar]);

    return null; // Este componente no renderiza nada en la UI
}

function App() {
    //Estado para el modo oscuro, obtener de LS de lo contrario false
    const [darkMode, setDarkMode] = useState(() => {
        const storedPreference = localStorage.getItem('darkMode');
        return storedPreference ? JSON.parse(storedPreference) : false;
    });
    const [selectedMenu, setSelectedMenu] = useState('Claims'); // Estado para el menú seleccionado
    const [showNavBar, setShowNavBar] = React.useState(true);

    // Efecto para guardar la preferencia en localStorage cuando cambie darkMode
    useEffect(() => {
        localStorage.setItem('darkMode', JSON.stringify(darkMode));
    }, [darkMode]);

    return (
        <HeroUIProvider>
            <Router>
                <AuthProvider>
                    <LocationHandler
                        setSelectedMenu={setSelectedMenu}
                        setShowNavBar={setShowNavBar}
                    />

                    {/* Mostrar el NavBar si showNavBar es true */}
                    {showNavBar && (
                        <NavBar
                            darkMode={darkMode}
                            setDarkMode={setDarkMode}
                            selectedMenu={selectedMenu}
                            setSelectedMenu={setSelectedMenu}
                        />
                    )}

                    {/* Contenido principal */}
                    <div className="max-w-full mx-auto"> {/* padding: 2, maxWidth: 1024, margin: 'auto' */}
                        <Routes>
                            {/* PROTECTED ROUTES */}
                            <Route path="/" element={ <ProtectedRoute> <Claims darkMode={darkMode} /> </ProtectedRoute> } />
                            <Route path="/case/:id" element={ <ProtectedRoute> < Caso /> </ProtectedRoute> } />
                            {/*<Route path="/tabla" element={ <ProtectedRoute> < TablaMaestra darkMode={darkMode} /> </ProtectedRoute> } />*/}
                            <Route path="/maestra" element={ <ProtectedRoute> < Maestra darkMode={darkMode} /> </ProtectedRoute> } />

                            {/* PUBLIC ROUTES */}
                            <Route path="/powerbi" element={< Powerbi />} />
                            <Route path="/powerbi-mobile" element={< PowerbiMobile />} />
                            <Route path="/powerbi-operaciones" element={< PowerbiOperaciones />} />
                            <Route path="/powerbi-operaciones-mobile" element={< PowerbiOperacionesMobile />} />
                            <Route path="/reporte" element={< ReporteCliente />} />
                            <Route path="/claimdetail" element={<ClaimDetailPublic />} />
                            <Route path="/legacy" element={<LegacyPublic />} />
                            <Route path="/carrier" element={<Carrier />} />

                            {/*TODO: convertir a protected*/}
                            <Route path="/exporter" element={<Exporter />} />
                            <Route path="/exporteractivate" element={<ExporterActivateAccount />} />

                            <Route path="/login" element={ <Login /> } />
                            <Route path="/404" element={ < NotFound /> } />
                            {/* Ruta no encontrada */}
                            <Route path="*" element={ < NotFound /> } />
                        </Routes>
                    </div>
                    <Toaster position="top-right" />
                </AuthProvider>
            </Router>
        </HeroUIProvider>
    );
}

export default App;
